export default __webpack_public_path__ + "static/media/Guaranteed_INO.c5e5c29e.mp4";